module.exports = __webpack_public_path__ + "img/footerLogo.be6b37fd.png";